import storage from 'modules/storage';

const PROMO_STORAGE_NAME = 'promo_banner_time_';

export const getBannerLastTime = (id: string): string | null => {
  const name = `${PROMO_STORAGE_NAME}${id}`;

  return storage.session.getItem(name);
};

export const setBannerTime = (id: string, time: number | string) => {
  const name = `${PROMO_STORAGE_NAME}${id}`;

  return storage.session.setItem(name, `${time}`);
};

export const addZeroToStartLine = (num: number): string =>
  num < 10 ? `0${num}` : `${num}`;
